import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { Mail, MapPin, ShieldCheck } from "lucide-react";
import { contactInfo } from "../mock/mock";

const Footer = () => {
  return (
    <footer className="bg-[#050f30] text-white/70 pt-16 pb-8 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo size={40} variant="light" />
          <p className="mt-5 text-sm leading-relaxed max-w-md">
            Explorer Picks is a private football predictions service run by
            Ryan Fletcher, delivering professionally researched selections to
            members across the world. Nearly three decades of dropping-odds expertise,
            covering almost all leagues, delivered to your inbox.
          </p>
          <div className="mt-5 flex items-center gap-3 text-xs text-white/50">
            <ShieldCheck size={16} className="text-[#ff5a5a]" />
            <span>18+ | Please gamble responsibly</span>
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">
            Explore
          </h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/" className="hover:text-[#ff5a5a] transition-colors">Home</Link></li>
            <li><Link to="/archive" className="hover:text-[#ff5a5a] transition-colors">Predictions Archive</Link></li>
            <li><Link to="/membership" className="hover:text-[#ff5a5a] transition-colors">Membership</Link></li>
            <li><Link to="/about" className="hover:text-[#ff5a5a] transition-colors">About</Link></li>
            <li><Link to="/faq" className="hover:text-[#ff5a5a] transition-colors">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-[#ff5a5a] transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">
            Legal
          </h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/terms" className="hover:text-[#ff5a5a] transition-colors">Terms &amp; Conditions</Link></li>
            <li><Link to="/privacy" className="hover:text-[#ff5a5a] transition-colors">Privacy Policy</Link></li>
            <li><Link to="/disclaimer" className="hover:text-[#ff5a5a] transition-colors">Disclaimer</Link></li>
          </ul>
          <div className="mt-6 space-y-2 text-sm break-all">
            <div className="flex items-center gap-2">
              <Mail size={14} className="text-[#ff5a5a] flex-shrink-0" />
              <a
                href={`mailto:${contactInfo.email}`}
                className="hover:text-[#ff5a5a] transition-colors"
              >
                {contactInfo.email}
              </a>
            </div>
            <div className="flex items-center gap-2">
              <MapPin size={14} className="text-[#ff5a5a] flex-shrink-0" />
              <span>{contactInfo.location}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
        <div>© 2022 Explorer Picks. All rights reserved.</div>
        <div>Made with precision for serious football bettors.</div>
      </div>
    </footer>
  );
};

export default Footer;
